import { CategoryListModel } from "../CategoryListModel";
export class CategoryList {

    static CategoryItem: Array<CategoryListModel> = [] as Array<CategoryListModel>;


    static get CategoryList() {
        return (this.CategoryItem = [
            { id: 1, name: 'Entrance Exam', ParentCategory: 11 },
            { id: 2, name: 'Physics (Class 11)', ParentCategory: 11 },
            { id: 3, name: 'Chemistry (Class 11)', ParentCategory: 11 },
            { id: 4, name: 'Mathematics (Class 11)', ParentCategory: 11 },
            { id: 5, name: 'Biology (Class 11)', ParentCategory: 11 },
            { id: 6, name: 'Entrance Exam', ParentCategory: 12 },
            { id: 7, name: 'Physics (Class 12)', ParentCategory: 12 },
            { id: 8, name: 'Chemistry (Class  12)', ParentCategory: 12 },
            { id: 9, name: 'Mathematics (Class 12)', ParentCategory: 12 },
            { id: 10, name: 'Biology (Class  12)', ParentCategory: 12 },
            { id: 50, name: 'Maths', ParentCategory: 6 },
            { id: 49, name: 'Science', ParentCategory: 6 }, // check it
            { id: 48, name: 'Maths', ParentCategory: 7 },
            { id: 47, name: 'Science', ParentCategory: 7 },
            { id: 46, name: 'Maths', ParentCategory: 8 },
            { id: 45, name: 'Science', ParentCategory: 8 },
            { id: 44, name: 'Maths', ParentCategory: 9 },
            { id: 43, name: 'Science', ParentCategory: 9 },
            { id: 42, name: 'Maths', ParentCategory: 10 },
            { id: 41, name: 'Science', ParentCategory: 10 },
        ]);
    }

}
